import * as React from 'react';
import './paymentInfoPane.module.scss';
import { observer, inject } from 'mobx-react';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import { SideBar } from './SideBar';
import { BackButtonHeader } from './BackButtonHeader';
import { V3Routes } from '../../../routes';
import { observable, makeObservable } from 'mobx';
import { PaymentInfoPaneState } from './states/PaymentInfoPaneState';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { CardInputV2 } from '../../molecules/payment/CardInput';
import { LoaderRow } from '../../atoms/layout/LoaderRow';
import { FormError } from '../../../../commonv3/components/atoms/forms/vertical';

type Props = {
  homeState: HomePageState;
};

export const PaymentInfoPane = inject('homeState')(
  observer(
    class PaymentInfoPane extends React.Component<Props> {
      pageState = new PaymentInfoPaneState();

      constructor(props: Props) {
        super(props);

        makeObservable(this, {
          pageState: observable,
        });
      }

      async componentDidMount() {
        await this.pageState.init();
      }

      render() {
        const {
          formState,
          initialized,
          success,
          submitState: { submitting },
        } = this.pageState;
        const { number, yy, mm, cvc } = formState.cardFormState.fields;
        return (
          <div styleName="pane" id="payment-info-pane">
            {GlobalStatesV3.viewport.isDesktop && <SideBar activeMenu="payments" />}
            <div styleName="main">
              <BackButtonHeader to={V3Routes.payments()} />
              <h2 styleName="h2">お支払い情報の変更</h2>
              {!initialized ? (
                <LoaderRow />
              ) : (
                <>
                  <CardInputV2 creditCardState={formState} />
                  {[number, yy, mm, cvc].map((e, i) => (
                    <FormError key={i} state={e} />
                  ))}
                  <div styleName="form-submit-button">
                    <Button
                      id="submit-button"
                      styleName="button"
                      size="m"
                      type={success ? 'success' : 'primary'}
                      loading={submitting}
                      onClick={() => this.pageState.submit()}
                      disabled={!formState.cardInputCompleteAll}
                    >
                      {success ? '更新しました' : '保存する'}
                    </Button>
                  </div>
                </>
              )}
            </div>
          </div>
        );
      }
    }
  )
);
